import React, {Component} from 'react';
import {
    Badge,
    Nav,
    NavItem,
    NavLink,
    NavbarToggler,
    NavbarBrand
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';

class Header extends Component {

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }
  renderBell(){
      if(this.props.notifications.length > 0){
          return(
              <NavLink onClick={this.asideToggle} href="#"><i className="fa fa-lg fa-bell"></i><Badge pill color="danger">{this.props.notifications.length}</Badge></NavLink>
          )
      }else{
          return(
              <NavLink onClick={this.asideToggle} href="#"><i className="fa fa-lg fa-bell-o"></i></NavLink>
          )
      }
  }

  render() {
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarBrand href="#"></NavbarBrand>
        <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
          <Nav className="ml-auto" navbar>
              <NavItem>
                  {this.renderBell()}
              </NavItem>
              <NavItem>
                <HeaderDropdown signOut={this.props.signOut} user={this.props.user} />
              </NavItem>
          </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./resources/assets/js/components/core/Header/Header.js